module.exports = __webpack_public_path__ + "img/selfridges-white.c01aa1ef.svg";